// Core
import React, { useState } from 'react';
import { Box, Flex, Text, Button, Image, useColorModeValue, useColorMode } from '@chakra-ui/react';

// Components
import Card from 'components/Card/Card';

const CoinsSpend = ({ data }) => {
    const border = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');
    const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

    const handleWheel = (e) => {
      const target = e.currentTarget;
      if (target) {
        e.preventDefault(); 
      }
    };

    const handleMouseDown = (e) => {
        const target = e.currentTarget;
        if (target) {
          const startX = e.pageX;
          const startScrollLeft = target.scrollLeft; 

          const onMouseMove = (moveEvent) => {
            if (target) {
              const deltaX = moveEvent.pageX - startX;
              target.scrollLeft = startScrollLeft - deltaX; 
            }
          };

          const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
          };

          document.addEventListener('mousemove', onMouseMove);
          document.addEventListener('mouseup', onMouseUp);
        }
    };

    return (
        <Flex
          position="relative"
          zIndex="99"
          ml={data.length > 1 ? '-4px' : '0px'}
          overflowX="scroll"
          p="0 12px 0 16px"
          mb="16px"
          css={{
            '&::-webkit-scrollbar': {
              display: 'none', 
            },
            '-ms-overflow-style': 'none', 
            'scrollbarWidth': 'none', 
            touchAction: 'pan-x', 
            WebkitOverflowScrolling: 'touch',
          }}
          onWheel={handleWheel}
          onMouseDown={handleMouseDown}
        >
          {data.map((item, index) => (
            <Box
              key={index}
              px="4px"
              w="270px"
              flexShrink={0} 
            >
                <Box zIndex="99" border={border} borderRadius="12px" overflow="hidden" position="relative">
                    <Box p="8px 8px 12px 8px" position="relative" w="100%">
                        <Flex
                            justifyContent="space-between"
                            >
                            <Box
                                borderRadius="8px"
                                bg="rgba(9, 155, 255, 0.10)"
                                p="4px"
                                w="32px"
                                h="32px"
                                >
                                <item.icon />
                            </Box>

                            { item.comingSoon && <Text
                                p="0px 8px"
                                borderRadius="30px"
                                h="22px"
                                border="1px solid #2ABDFD"
                                fontSize="15px"
                                fontStyle="italic"
                                fontWeight="700"
                                lineHeight="19px"
                                letterSpacing="-1px"
                                textTransform="capitalize"
                                >Coming soon</Text>
                            }
                        </Flex>
                        <Text variant="title-md" mt="8px">{item?.title}</Text>
                        <Text variant="text-md" fontSize="15px" mt="5px">{item?.description}</Text>
                    </Box>

                    { isDark &&
                        <Box
                            position="absolute"
                            borderRadius="100%"
                            bg="#099BFF"
                            filter="blur(30px)"
                            w="100%"
                            h="30px"
                            />
                    }
                </Box>
            </Box>
          ))}
        </Flex>
    );
};

export default CoinsSpend;
